module.exports = __webpack_public_path__ + "img/C2.08f70c63.jpg";